import { HIDE_ALERT } from "./types/alertTypes";

export const closeAlert = () => ({
  type: HIDE_ALERT
});
